export enum DataUrl {
    Home = "./home.json",
}
